import {useEffect} from "react";
import {clearStaleSession, markPageHidden} from "../../util/staleSession";

// REQUIRED USE-CASE:
// Navigating away from the website or restoring a browser session (crash, force close, etc)
// should log the user out and not return them back to their previous valid session.
//
// THIS RECORDS; `clearStaleSession` IN index.tsx DECIDES. Until 2026-10-27 only the first half
// existed: this component wrote `appUnloadedAt` and nothing anywhere read it, so the requirement
// above was a comment rather than a behaviour. See util/staleSession.ts.
export function AppUnloadLogout() {

    useEffect(() => {

        // `pagehide`, NOT `unload`. Chrome blocks `unload` by permissions policy -- "[Violation]
        // Permissions policy violation: unload is not allowed in this document" -- so the listener
        // this component used to register could not fire at all. `pagehide` is the supported event
        // and, unlike `unload`, it also fires when the page goes into the back/forward cache.
        const hidden = () => markPageHidden();

        // A bfcache RESTORE NEVER RE-RUNS index.tsx, so the check on the way in does not happen.
        // `pageshow` with `persisted` is that case, and it is the one a plain reload is not.
        const shown = (event: PageTransitionEvent) => {
            if (event.persisted && clearStaleSession()) {
                window.location.assign("/");
            }
        };

        window.addEventListener("pagehide", hidden);
        window.addEventListener("pageshow", shown);

        return () => {
            window.removeEventListener("pagehide", hidden);
            window.removeEventListener("pageshow", shown);
        };

    }, []);

    return null;
}
